/* import __COLOCATED_TEMPLATE__ from './styles.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();